import styled from 'styled-components';

const toneFor = (status: string) => {
  if (/취소|불가|사고/.test(status)) return 'error';
  if (/환불|반품/.test(status)) return 'accent';
  if (status === '결제완료' || status === '배송완료') return 'success';
  if (status === '배송중') return 'accent';
  if (/대기|준비|발주|확인 중/.test(status)) return 'warning';
  return 'neutral';
};

export function latestDeliveryStatus(items: { order_status: string; status_update_dt?: string }[]) {
  const ranks: Record<string, number> = { 결제대기: 0, 결제완료: 1, 발주완료: 2, 배송준비: 2, 배송중: 3, 배송완료: 4, 주문취소: 5, 환불처리: 6, 사고처리: 6 };
  const latest = [...items].sort((a, b) => (Date.parse(b.status_update_dt || '') || 0) - (Date.parse(a.status_update_dt || '') || 0)
    || (ranks[b.order_status] || 0) - (ranks[a.order_status] || 0))[0];
  return latest ? [['주문취소', '환불처리'].includes(latest.order_status) ? '취소 완료' : latest.order_status === '사고처리' ? '관리자 확인 중' : latest.order_status] : [];
}

export default function BillDeliveryStatuses({ statuses, label = '배송 상태' }: { statuses: string[]; label?: string }) {
  return <Statuses aria-label={label}>{Array.from(new Set(statuses)).map(status =>
    <Status key={status} $tone={toneFor(status)}>{status}</Status>
  )}{!statuses.length && <span>주문 정보 없음</span>}</Statuses>;
}

const Statuses = styled.div`display:flex;align-items:center;flex-wrap:wrap;gap:6px;min-width:0;`;
const Status = styled.span<{ $tone: string }>`
  display:inline-block;padding:4px 8px;border-radius:6px;font-size:13px;font-weight:600;line-height:1.4;
  color:${p => p.$tone === 'neutral' ? 'var(--user-text-muted)' : `var(--user-${p.$tone})`};
  background:${p => p.$tone === 'neutral' ? 'var(--user-surface-raised)' : `var(--user-${p.$tone}-soft)`};
  overflow-wrap:anywhere;
`;
